import React from "react";
import Icon from "@ant-design/icons";

const TextSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path d="M20,7h-6v14h-4V7H4V4h16V7z" />
  </svg>
);

type CustomVPDIconProps = {
  [x: string]: any;
};

export const TextIcon = (props: CustomVPDIconProps): JSX.Element => (
  <Icon component={TextSvg} {...props} />
);
